import { nameSearchEvent, settleNameSearchEvent, type NameHit, type NameSearchBox } from "@teamna/shared";
import { useEffect, useState } from "react";
import { track } from "../analytics/web.ts";

/**
 * Sends `name_search_used` once the person stops typing in a name search box, once for each typed
 * text. Counts and the best band only, never the text. `results` are the name hits of the search
 * (`searchByName(...).results`); `resultCount` also counts rows let in by another rule. With no
 * `box` (a shared box whose caller did not name it), nothing is sent. The phone has the same
 * hook on its own tracker (`apps/mobile/src/hooks/use-track-name-search.ts`).
 */
export function useTrackNameSearch(
  box: NameSearchBox | null,
  typed: string,
  results: readonly { hit: NameHit }[],
  resultCount: number = results.length,
): void {
  const event = box ? nameSearchEvent(box, typed, results, resultCount) : null;
  // Every text sent from this box. One Set for the life of the box.
  const [sent] = useState(() => new Set<string>());
  // The effect runs again only when what the event says changes, not on every render.
  const said = event ? `${event.search_box}|${event.word_count}|${event.result_count}|${event.top_band}` : "";
  useEffect(
    () => settleNameSearchEvent(event, typed, sent, (props) => track("name_search_used", props)),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `said` stands for `event`
    [said, typed],
  );
}
